import React from 'react';
import Link from 'next/link';

import { formatEther } from '../util';
import useRainbowBalance from '../hooks/useRainbowBalance';

const RainbowBalance = ({ price }) => {
  const rainbowBalance = useRainbowBalance();

  return (
    <>
      {rainbowBalance.current.lt(price) ? (
        <div className="alert alert-danger text-center">
          You don&lsquo;t have enough $RAINBOWS
        </div>
      ) : (
        ''
      )}
      <div>
        <strong>Wallet balance:</strong> {formatEther(rainbowBalance.current)}{' '}
        $RAINBOWS
        {/*
        <br />
        <strong>Pending balance:</strong>{' '}
        {formatEther(rainbowBalance.pending.total)} $RAINBOWS (
        <Link href="/dashboard">
          <a className="link-secondary">claim</a>
        </Link>
        )
        */}
      </div>
    </>
  );
};

export default RainbowBalance;
